"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var color = {
  RED: 'red',
  GREEN: 'green',
  GREY: 'grey',
  YELLOW: 'yellow'
};
var singlePoint = {
  0: color.GREEN,
  //Open
  1: color.RED,
  // Close
  99: color.GREY // default

};
var doublePoint = {
  0: color.GREY,
  //Invalid
  1: color.GREEN,
  //Open
  2: color.RED,
  //Close
  3: color.YELLOW,
  //Intermediate
  99: color.GREY // default

};
var colorTextValues = {
  0: 'ZerosColor',
  1: 'OnesColor',
  2: 'TwosColor',
  3: 'ThreesColor'
};
var _default = {
  color: color,
  singlePoint: singlePoint,
  doublePoint: doublePoint,
  colorTextValues: colorTextValues
};
exports.default = _default;